import { Image } from "primereact/image";

import elementNotFoundImage from "assets/images/element_not_found.svg";
import { useState } from "react";

export const EmptyMessageTable = ({ label }: { label: string }) => {
  const [showLabel, setShowLabel] = useState(false);
  return (
    <div className="flex-container column justify-center align-center empty-message-container margin-bottom-30">
      {label?.length > 0 && (
        <Image
          src={elementNotFoundImage}
          className="width-px-180"
          onLoad={() => setShowLabel(true)}
        />
      )}
      {showLabel && (
        <>
          <span className="text-center width-px-220">{label}</span>
        </>
      )}
    </div>
  );
};
